import { assert } from '../../lib/assert-sidecar'
import { common } from '../../main/common-sidecar'
import { EVoyageCarryableType } from './voyageCarryable'
import { voyageCarryable } from './voyageCarryable-sidecar'
import type { IVoyageCrew } from './voyageCrew'

export function onEnter(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  if (!obj.carryable) {
    obj.carryable = voyageCarryable.create(EVoyageCarryableType.Coffee)
    voyageCarryable.moveToXY(obj.carryable, obj.x, obj.y)
  } else if (
    obj.carryable &&
    obj.carryable.type === EVoyageCarryableType.Coffee
  ) {
    voyageCarryable.kill(obj.carryable)
    obj.carryable = null
  }
}
